import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "logo-wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { id: "nav-list" }
const _hoisted_5 = ["id", "onClick", "onMouseover", "title"]
const _hoisted_6 = { class: "menu-item-wrapper" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "arrow-icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "menu-item-wrapper"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "arrow-icon" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "arrow-icon" }
const _hoisted_38 = ["src"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 4,
  class: "menu-item-wrapper"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  class: "side-logo-wrapper"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  class: "profile",
  ref: "popup"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = ["href", "onClick"]
const _hoisted_50 = { class: "menu-wrapper" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "spacing" }
const _hoisted_53 = { slot: "body" }
const _hoisted_54 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Admin = _resolveComponent("Admin")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AlertPopup = _resolveComponent("AlertPopup")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([{ mini: _ctx.mini }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.imageType === 'svg')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "logo1w",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
          }, [
            _createElementVNode("div", { innerHTML: _ctx.logo }, null, 8, _hoisted_2)
          ]))
        : (_ctx.imageType === 'others')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "logo1",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.logo,
                alt: " image",
                class: "logo-type"
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header, ({ disable, path, icon, iconActive, label, dropdown }, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: index,
            to: path,
            class: "link",
            active: _ctx.isActive,
            href: _ctx.href,
            onClick: _ctx.navigate
          }, {
            default: _withCtx(({ href, navigate, isActive }) => [
              (!disable)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    id: `nav-item-${index}`,
                    onClick: ($event: any) => (_ctx.setActive(index)),
                    onMouseout: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hovering=-1)),
                    onMouseover: ($event: any) => (_ctx.hovering=index),
                    class: _normalizeClass([{ 'has-drop': dropdown && dropdown.length > 0, 'dd-flip': _ctx.isOutOfView(`nav-item-${index}`), 'active-li': _ctx.activeIndex === index}, label]),
                    style: _normalizeStyle(_ctx.customStyle),
                    title: label
                  }, [
                    (label === _ctx.HEADERS.MANAGE)
                      ? (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 0,
                          trigger: "click",
                          "popper-class": "manage-menu",
                          ref_for: true,
                          ref: "manageMenu",
                          onVisibleChange: _ctx.handlePopupClose
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_Admin, { onClosePopup: _ctx.handleClosePopup }, null, 8, ["onClosePopup"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              (_ctx.activeIndex === index && iconActive)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: iconActive,
                                      alt: "svg image"
                                    }, null, 8, _hoisted_8), [
                                      [_directive_svg_inline]
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: icon,
                                      alt: "svg image"
                                    }, null, 8, _hoisted_10), [
                                      [_directive_svg_inline]
                                    ])
                                  ])),
                              _createElementVNode("span", {
                                class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                              }, _toDisplayString(label), 3),
                              _createElementVNode("span", _hoisted_11, [
                                _withDirectives(_createElementVNode("img", {
                                  src: _ctx.arrowDownIcon,
                                  alt: "svg image"
                                }, null, 8, _hoisted_12), [
                                  [_directive_svg_inline]
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onVisibleChange"]))
                      : (label === _ctx.HEADERS.CLIENT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.activeIndex === index && iconActive)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: iconActive,
                                    alt: "svg image"
                                  }, null, 8, _hoisted_15), [
                                    [_directive_svg_inline]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: icon,
                                    alt: "svg image"
                                  }, null, 8, _hoisted_17), [
                                    [_directive_svg_inline]
                                  ])
                                ])),
                            _createElementVNode("span", {
                              class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                            }, _toDisplayString(label === _ctx.HEADERS.CLIENT && _ctx.currentUser.systemRole === 'supervisor' || _ctx.currentUser.systemRole === 'director' ? 'Clients/Advisers' : label), 3)
                          ]))
                        : (label === _ctx.HEADERS.EFNA)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              ([0, 1].includes(_ctx.userAccessViews.length))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "efna-menu-item menu-item-wrapper",
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onEfnaClick && _ctx.onEfnaClick(...args)))
                                  }, [
                                    (_ctx.activeIndex === index && iconActive)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                          _withDirectives(_createElementVNode("img", {
                                            src: iconActive,
                                            alt: "svg image"
                                          }, null, 8, _hoisted_19), [
                                            [_directive_svg_inline]
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                          _withDirectives(_createElementVNode("img", {
                                            src: icon,
                                            alt: "svg image"
                                          }, null, 8, _hoisted_21), [
                                            [_directive_svg_inline]
                                          ])
                                        ])),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                                    }, _toDisplayString(label), 3)
                                  ]))
                                : (_openBlock(), _createBlock(_component_el_dropdown, {
                                    key: 1,
                                    trigger: "click",
                                    "popper-class": "efna-menu",
                                    onVisibleChange: _ctx.handlePopupClose,
                                    placement: "bottom-start"
                                  }, {
                                    dropdown: _withCtx(() => [
                                      _createVNode(_component_el_dropdown_menu, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAccessViews, (item, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: i,
                                              class: _normalizeClass([{'hide': item.shouldHide}, "menu-dropdown-item"]),
                                              onClick: ($event: any) => (_ctx.handleEfnaRoute(item.href))
                                            }, [
                                              _createVNode(_component_el_dropdown_item, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.label), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ], 10, _hoisted_28))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "menu-item-wrapper",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEfnaClick && _ctx.onEfnaClick(...args)))
                                      }, [
                                        (_ctx.activeIndex === index && iconActive)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: iconActive,
                                                alt: "svg image"
                                              }, null, 8, _hoisted_23), [
                                                [_directive_svg_inline]
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: icon,
                                                alt: "svg image"
                                              }, null, 8, _hoisted_25), [
                                                [_directive_svg_inline]
                                              ])
                                            ])),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                                        }, _toDisplayString(label), 3),
                                        _createElementVNode("span", _hoisted_26, [
                                          _withDirectives(_createElementVNode("img", {
                                            src: _ctx.arrowDownIcon,
                                            alt: "svg image"
                                          }, null, 8, _hoisted_27), [
                                            [_directive_svg_inline]
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onVisibleChange"]))
                            ], 64))
                          : (label === _ctx.HEADERS.REPORT)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (_ctx.reportOptions.length === 1)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["menu-item-wrapper", {'efna-menu-item': _ctx.reportOptions.length > 1}]),
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReportClick && _ctx.onReportClick(...args)))
                                    }, [
                                      (_ctx.activeIndex === index && iconActive)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                            _withDirectives(_createElementVNode("img", {
                                              src: iconActive,
                                              alt: "svg image"
                                            }, null, 8, _hoisted_30), [
                                              [_directive_svg_inline]
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                            _withDirectives(_createElementVNode("img", {
                                              src: icon,
                                              alt: "svg image"
                                            }, null, 8, _hoisted_32), [
                                              [_directive_svg_inline]
                                            ])
                                          ])),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                                      }, _toDisplayString(label), 3)
                                    ], 2))
                                  : (_openBlock(), _createBlock(_component_el_dropdown, {
                                      key: 1,
                                      trigger: "click",
                                      "popper-class": "efna-menu",
                                      onVisibleChange: _ctx.handlePopupClose,
                                      placement: "bottom-start"
                                    }, {
                                      dropdown: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_menu, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportOptions, (item, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: i,
                                                class: _normalizeClass([{'hide': item.shouldHide}, "menu-dropdown-item"]),
                                                onClick: ($event: any) => (_ctx.handleReportRoute(item))
                                              }, [
                                                _createVNode(_component_el_dropdown_item, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ], 10, _hoisted_39))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "menu-item-wrapper",
                                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReportClick && _ctx.onReportClick(...args)))
                                        }, [
                                          (_ctx.activeIndex === index && iconActive)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                _withDirectives(_createElementVNode("img", {
                                                  src: iconActive,
                                                  alt: "svg image"
                                                }, null, 8, _hoisted_34), [
                                                  [_directive_svg_inline]
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                                _withDirectives(_createElementVNode("img", {
                                                  src: icon,
                                                  alt: "svg image"
                                                }, null, 8, _hoisted_36), [
                                                  [_directive_svg_inline]
                                                ])
                                              ])),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                                          }, _toDisplayString(label), 3),
                                          _createElementVNode("span", _hoisted_37, [
                                            _withDirectives(_createElementVNode("img", {
                                              src: _ctx.arrowDownIcon,
                                              alt: "svg image"
                                            }, null, 8, _hoisted_38), [
                                              [_directive_svg_inline]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onVisibleChange"]))
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                (_ctx.activeIndex === index && iconActive)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                      _withDirectives(_createElementVNode("img", {
                                        src: iconActive,
                                        alt: "svg image"
                                      }, null, 8, _hoisted_42), [
                                        [_directive_svg_inline]
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                      _withDirectives(_createElementVNode("img", {
                                        src: icon,
                                        alt: "svg image"
                                      }, null, 8, _hoisted_44), [
                                        [_directive_svg_inline]
                                      ])
                                    ])),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["menuLabel", _ctx.activeIndex === index ? 'activeMenuLabel' : 'inactiveMenuLabel'])
                                }, _toDisplayString(label), 3)
                              ]))
                  ], 46, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to", "active", "href", "onClick"]))
        }), 128))
      ]),
      (_ctx.showSideLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _withDirectives(_createElementVNode("img", {
              id: "mochaLogo",
              class: "mocha-logo side-logo",
              src: _ctx.mochaIcon,
              alt: "svg image",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
            }, null, 8, _hoisted_46), [
              [_directive_svg_inline]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDropdown = true)),
        class: "dropdown-pro"
      }, [
        _withDirectives(_createElementVNode("img", {
          id: "profile",
          class: "profile-logo side-logo",
          src: _ctx.profileIcon,
          alt: "svg image"
        }, null, 8, _hoisted_48), [
          [_directive_svg_inline]
        ]),
        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
          default: _withCtx(() => [
            _createVNode(_component_arrow_down)
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", {
        id: "myDropdown",
        class: "dropdown-content",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handlePopupClick && _ctx.handlePopupClick(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileOptions, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            class: _normalizeClass(item.label),
            href: item.href ? item.href : undefined,
            onClick: ($event: any) => (_ctx.handleEvent(item.event))
          }, [
            _createElementVNode("div", _hoisted_50, [
              (item.icon)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 0,
                    id: "profile",
                    class: "profile-logo side-logo",
                    src: item.icon,
                    alt: "svg image"
                  }, null, 8, _hoisted_51)), [
                    [_directive_svg_inline]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_52, _toDisplayString(item.label), 1)
            ])
          ], 10, _hoisted_49))
        }), 128))
      ], 512), [
        [_vShow, _ctx.showDropdown]
      ])
    ], 512),
    (_ctx.enableVirtualMeeting)
      ? (_openBlock(), _createBlock(_component_AppDialog, {
          key: 0,
          class: "virtual-meeting-url",
          onClosed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isCopied = false)),
          hideFooter: true
        }, {
          header: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("Virtual Meeting URL")
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("p", null, [
                _cache[14] || (_cache[14] = _createTextVNode("Click on the URL to copy: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.isCopied ? 'Copied!' : ''), 1)
              ]),
              _createElementVNode("div", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args))),
                class: "jitsi-url"
              }, [
                _createElementVNode("input", {
                  id: "url",
                  value: _ctx.jitsiUrl,
                  readonly: ""
                }, null, 8, _hoisted_54)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isClosePopupVisible)
      ? (_openBlock(), _createBlock(_component_AlertPopup, {
          key: 1,
          showModal: _ctx.isClosePopupVisible,
          title: _ctx.noAccessDashboardAccessContent.title,
          message: _ctx.noAccessDashboardAccessContent.message,
          btnText: _ctx.noAccessDashboardAccessContent.btnText,
          type: _ctx.noAccessDashboardAccessContent.type,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isClosePopupVisible = false))
        }, null, 8, ["showModal", "title", "message", "btnText", "type"]))
      : _createCommentVNode("", true)
  ], 2))
}